<template>
	<div>
		<v-layout row wrap>
			<financial-table-element
				lighten='0'
				xs='10'
				:text="administrativeTitle"
			></financial-table-element>

			<financial-table-element
				lighten='0'
				xs='2'
				:text="administrative"
			></financial-table-element>
		</v-layout>
		<v-layout row wrap>
			<financial-table-element
				lighten='0'
				xs='10'
				:text="contributionTitle"
			></financial-table-element>

			<financial-table-element
				lighten='0'
				xs='2'
				:text="contribution"
			></financial-table-element>
		</v-layout>
	</div>
</template>

<script>
	import FinancialTableElement from "../FinancialTableRowElement";

	export default {
		name: "CostsLimitsSummary",
		components: {FinancialTableElement},

		props: {
			administrative: String,
			administrativeTitle: String,
			contribution: String,
			contributionTitle: String,
		}
	};
</script>

<style scoped>

</style>